<template>
  <div class="server-row">
    <!-- server name -->
    <div
      class="field name-field"
      :class="{ disabled: !server.active }"
      @click="$emit('selected')"
    >
      {{ server.name }}
    </div>
    <!-- used RAM bar -->
    <div class="field memory-field">
      <memory-usage-bar
        v-if="server.active"
        :full-memory="server.fullMemory"
        :used-memory="server.memoryUsage"
        class="usage-bar"
      />
    </div>
    <!-- used CPU bar -->
    <div class="field cpu-field">
      <percentage-usage-bar
        v-if="server.active"
        :usage="server.cpuUsage"
        class="usage-bar"
      />
    </div>
    <!-- streams count -->
    <div class="field streams-field">
      <span v-if="server.active">{{ server.streams.length }}</span>
    </div>
    <!-- server status -->
    <div class="field status-field">
      <span v-if="server.active" class="enabled">ON</span>
      <span v-else class="disabled">OFF</span>
    </div>
    <!-- server status scaling-->
    <!-- <div class="field status-field">
      <span v-if="server.active" class="enabled">Need</span>
      <span v-else class="disabled">Don't have to</span>
    </div> -->
  </div>
</template>

<script>
import PercentageUsageBar from "@/components/admin/bars/PercentageUsageBar.vue";
import MemoryUsageBar from "@/components/admin/bars/MemoryUsageBar.vue";

// @group Admin Page
// Row with short information about server
export default {
  name: "AdminServerShortInfo",
  components: {
    PercentageUsageBar,
    MemoryUsageBar
  },
  props: {
    // server information
    server: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.server-row {
  display: flex;
}

.field {
  text-align: center;
}
.name-field {
  width: 150px;
  cursor: pointer;

  /** long name ellipsis */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.name-field:hover {
  font-weight: bold;
}
.memory-field {
  width: 200px;
  flex-grow: 1;
  padding-right: 5px;
}
.cpu-field {
  width: 200px;
  flex-grow: 1;
  padding-left: 5px;
}
.streams-field {
  width: 150px;
}
.status-field {
  width: 100px;
  font-family: var(--sans-font);
}

.usage-bar {
  font-size: var(--tiny-font-sz);
}
.enabled {
  color: var(--success-color);
}
.disabled {
  color: var(--error-color);
}

@media only screen and (max-width: 400px) {
  .name-field {
    flex-grow: 1;
    text-align: start;
  }
  .name-field.disabled {
    color: var(--error-color);
  }
  .memory-field,
  .cpu-field,
  .streams-field,
  .status-field {
    display: none;
  }
}
@media only screen and (max-width: 640px) {
  .field {
    font-size: var(--tiny-font-sz);
  }
  .streams-field {
    display: none;
  }
}
</style>
